import { InputComponentProps, ValidatingInput } from '~/components/validating-input';

const KWH_LOWER_LIMIT = 0;
const KWH_UPPER_LIMIT = 3600;

export const EstimatedMonthlyKwh = ({ ...props }: InputComponentProps) => {
  const validate = ({ value }) => {
    if (Number(value) > KWH_LOWER_LIMIT && Number(value) <= KWH_UPPER_LIMIT) return true;
    return 'Please enter a valid estimated monthly kWh';
  };

  return (
    <ValidatingInput
      {...props}
      label="Usage in kWh for the selected month"
      name="estimatedMonthlyKwh"
      validate={validate}
      type="number"
    />
  );
};
